import React, { useState } from 'react';

// import SerialAddHistory from './SerialAddHistory';
import { Card } from '@mui/material';
import { useNavigate, useLocation } from 'react-router-dom';
// import { APIROOT } from '../../Helpers/configs';

import { Stack, Button, Modal, Box } from '@mui/material';

function SerialInfoActionCard(props) {
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const navigate = useNavigate();
  return (
    <Card sx={{ background: 'none', border: 'none', boxShadow: 'none' }}>
      <Stack
        spacing={2}
        direction='row'
        sx={{ float: 'right', margin: '15px' }}
      >
        <Button
          variant='outlined'
          onClick={() => {
            navigate(`/serial`, { replace: true });
          }}
        >
          Back
        </Button>
      </Stack>
    </Card>
  );
}

export default SerialInfoActionCard;

// function CreateEntry(entry) {
//   //Get JWT from storage
//   let JWT = localStorage.getItem('JWT_Key');

//   //Set default Headers
//   let headers = {
//     'content-type': 'application/JSON',
//   };
//   //Set JWT in header if available
//   if (JWT) {
//     headers['x-api-key'] = JWT;
//   }

//   let body = {
//     serialhistory: entry,
//   };

//   const request = new Request(`${APIROOT}/api/serialnumberhistory`, {
//     method: 'POST',
//     headers: headers,
//     body: JSON.stringify(body),
//   });

//   fetch(request)
//     .then((data) => {
//       if (data.status === 200) {
//         return data.text();
//       } else {
//         throw new Error(`Invalid Response`);
//       }
//     })
//     .then((data) => {
//       var parsed = JSON.parse(data);
//       if (parsed.success === true) {
//         console.log('entry created!');
//       }
//     })
//     .catch((error) => {
//       console.log(error);
//     });
// }

// import React from 'react';

// import Card from '@mui/material/Card';
// import { useNavigate, useLocation } from 'react-router-dom';

// import Stack from '@mui/material/Stack';
// import Button from '@mui/material/Button';

// function SerialInfoActionCard() {
//   const navigate = useNavigate();
//   return (
//     <Card sx={{ background: 'none', border: 'none', boxShadow: 'none' }}>
//       <Stack
//         spacing={2}
//         direction='row'
//         sx={{ float: 'right', margin: '15px' }}
//       >
//         <Button
//           variant='outlined'
//           onClick={() => {
//             navigate(`/serial`, { replace: true });
//           }}
//         >
//           Back
//         </Button>
//       </Stack>
//     </Card>
//   );
// }

// export default SerialInfoActionCard;
